var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminTable',{attrs:{"id":"admin-user-balance-withdraw","columns":_vm.columns,"title":`Коллекция userbalancewithdraws`,"model-name":"userBalanceWithdrawModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }